import { Component, TemplateRef, ViewChild } from '@angular/core';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { CasesComponent } from '../../../features/manage-organization/insights/cases/cases.component';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { ImportStudentComponent } from '../../../features/manage-organization/insights/students/import-student/import-student.component';
import { StudentsComponent } from '../../../features/manage-organization/insights/students/students.component';
import { DrawerService } from '../../../core/services/drawer.service';
import { CommonModule } from '@angular/common';
import { DRAWER_IDS } from '../../../core/constants/drawer-ids.constant';

@Component({
  selector: 'app-insights',
  standalone: true,
  imports: [
    NzTabsModule,
    CasesComponent,
    NzButtonModule,
    StudentsComponent,
    CommonModule,
  ],
  templateUrl: './insights.component.html',
  styleUrl: './insights.component.scss',
})
export class InsightsComponent {
  @ViewChild('footerTpl') footerTpl!: TemplateRef<void>;
  selectedTabIndex = 0;

  constructor(private drawerService: DrawerService) {}

  selectTab(index: number): void {
    this.selectedTabIndex = index;
  }
  openStudentDrawer(): void {
    this.drawerService.openDrawer(
      ImportStudentComponent,
      'Import Student',
      520,
      true,
      this.footerTpl as unknown as TemplateRef<object>,
      undefined,
      DRAWER_IDS.STUDENT
    );
  }
}
